import React, { Fragment, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import AxisSpinner from "./AxisSpinner";
import DateTimePicker from "react-datetime-picker";
import { useLocation, useNavigate } from "react-router-dom";
import DropDownUserRoleSelection from "./DropDownUserRoleSelection";
import { ButtonModalFormSaveClose } from "./ButtonModalSelection";

const UserCreation = ({ user = null, onComplete, close = null }) => {
  const { authAxios } = useAuth();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(null);
  const [emailValid, setEmailValid] = useState(false);
  const [emailValidationLoading, setEmailValidationLoading] = useState(false);
  const [emailRejectReason, setEmailRejectReason] = useState("email required");
  const [password, setPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [passwordRejectReason, setPasswordRejectReason] = useState(null);
  const [confirmPasswordRejectReason, setConfirmPasswordRejectReason] =
    useState(null);
  const [passwordValid, setPasswordValid] = useState(false);
  const [confirmPasswordValid, setConfirmPasswordValid] = useState(false);
  const [forename, setForename] = useState(null);
  const [surname, setSurname] = useState(null);
  const [forenameValid, setForenameValid] = useState(false);
  const [surnameValid, setSurnameValid] = useState(false);
  const [forenameRejectReason, setFornameRejectReason] = useState("required");
  const [surnameRejectReason, setSurnameRejectReason] = useState("required");
  const [staffNumber, setStaffNumber] = useState(null);
  const [nmcNumber, setNmcNumber] = useState(null);
  const [accessniNumber, setAccessniNumber] = useState(null);
  const [eLearnUsername, setELearnUsername] = useState(null);
  const [telephone, setTelephone] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [startDateValid, setStartDateValid] = useState(false);
  const [role, setRole] = useState(null);
  const [roleValid, setRoleValid] = useState(false);
  const [needGradeTypeSelection, setNeedGradeTypeSelection] = useState(false);
  const [isRn, setRn] = useState(false);
  const [isRm, setRm] = useState(false);
  const [isRmn, setRmn] = useState(false);
  const [isRnld, setRnld] = useState(false);
  const [isHca2, setHca2] = useState(false);
  const [isHca3, setHca3] = useState(false);
  const [isRscn, setRscn] = useState(false);
  const [isLdoc, setLdoc] = useState(false);
  const [isLcon, setLcon] = useState(false);
  const [isSupportWorker, setSupportWorker] = useState(false);
  const [isRadiographer, setRadiographer] = useState(false);
  const [isPhysiotherapist, setPhysiotherapist] = useState(false);
  const [isLabAssistant, setLabAssistant] = useState(false);
  const [isBioMedicalScientist, setBioMedicalScientist] = useState(false);
  const [isSpeechTherapist, setSpeechTherapist] = useState(false);
  const [isOccupationalTherapist, setOccupationalTherapist] = useState(false);
  const [isPharmacist, setPharmacist] = useState(false);
  const [status, setStatus] = useState("ACTIVE");
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [availableTrusts, setAvailableTrusts] = useState([]);
  const [selectedTrustIds, setSelectedTrustIds] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchTrusts = async () => {
      try {
        const response = await authAxios().get("/api/trusts/");
        setAvailableTrusts(response.data);
      } catch (err) {
        console.log("error fetching trusts:");
        console.log(err);
      }
    };
    fetchTrusts();
  }, []);

  useEffect(() => {
    if (user === null || user === undefined || user.id === undefined) {
      setSelectedTrustIds([]);
      return;
    }
    const fetchUserTrusts = async () => {
      try {
        const response = await authAxios().get(
          "/api/backoffice/users/user_trusts",
          { params: { user_id: user.id } },
        );
        setSelectedTrustIds(response.data);
      } catch (err) {
        console.log("error fetching user trusts:");
        console.log(err);
        setSelectedTrustIds([]);
      }
    };
    fetchUserTrusts();
  }, [user]);

  const toggleTrust = (trustId) => {
    setSelectedTrustIds((prev) =>
      prev.includes(trustId)
        ? prev.filter((id) => id !== trustId)
        : [...prev, trustId],
    );
  };

  useEffect(() => {
    if (user === null || user === undefined) return;

    setForename(user?.forename);
    setSurname(user?.surname);
    setEmail(user?.email);
    setStatus(user?.status);
    setRole(user?.role);
    setStaffNumber(user?.staffNumber);
    setAccessniNumber(user?.accessNINumber);
    setELearnUsername(user?.eLearnUsername);
    setNmcNumber(user?.nmcNumber);
    setTelephone(user?.telephone);
    if (user?.startDate) setStartDate(new Date(user?.startDate));
    setRn(user?.rn);
    setRm(user?.rm);
    setRmn(user?.rmn);
    setRnld(user?.rnld);
    setRscn(user?.rscn);
    setHca2(user?.hca2);
    setHca3(user?.hca3);
    setLdoc(user?.ldoc);
    setLcon(user?.lcon);
    setSupportWorker(user?.supportWorker);
    setRadiographer(user?.radiographer);
    setPhysiotherapist(user?.physiotherapist);
    setLabAssistant(user?.labAssistant);
    setBioMedicalScientist(user?.bioMedicalScientist);
    setSpeechTherapist(user?.speechTherapist);
    setOccupationalTherapist(user?.occupationalTherapist);
    setPharmacist(user?.pharmacist);
  }, [user]);

  useEffect(() => {
    validateEmail();
  }, [email]);

  useEffect(() => {
    const valid =
      forename !== null &&
      forename !== undefined &&
      forename !== "" &&
      forename?.length > 0;
    setForenameValid(valid);
  }, [forename]);

  useEffect(() => {
    const valid =
      surname !== null &&
      surname !== undefined &&
      surname !== "" &&
      surname?.length > 0;
    setSurnameValid(valid);
  }, [surname]);

  useEffect(() => {
    const pvalid =
      password !== null &&
      password !== undefined &&
      password !== "" &&
      password.length > 0;
    const cvalid =
      confirmPassword !== null &&
      confirmPassword !== undefined &&
      confirmPassword !== "" &&
      confirmPassword === password &&
      confirmPassword?.length > 0;

    setPasswordValid(pvalid);
    setConfirmPasswordValid(cvalid);

    if (!pvalid) setPasswordRejectReason("invalid password");
    if (!cvalid) setConfirmPasswordRejectReason("password does not match");
  }, [password, confirmPassword]);

  useEffect(() => {
    const valid = startDate !== null && startDate !== undefined;
    setStartDateValid(valid);
  }, [startDate]);

  useEffect(() => {
    const valid = role !== null && role !== undefined;
    setRoleValid(valid);
    setNeedGradeTypeSelection(valid && role === "USER");
  }, [role]);

  useEffect(() => {
    const needPassword = user === null || user === undefined;
    const validForm =
      forenameValid &&
      surnameValid &&
      startDateValid &&
      roleValid &&
      (needPassword ? passwordValid && confirmPasswordValid : true);
    setSaveDisabled(!validForm);
  }, [
    forenameValid,
    surnameValid,
    passwordValid,
    confirmPasswordValid,
    startDateValid,
    roleValid,
  ]);

  const validateEmail = async () => {
    if (email === null || email === undefined || email === "") return;

    setEmailValidationLoading(true);
    try {
      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const response = await authAxios().post(
        "/api/backoffice/users/validate_email",
        { email: email, userId: user?.id },
        config,
      );

      setEmailValid(response.data.valid);
      setEmailRejectReason(response.data.rejectReason);
      setEmailValidationLoading(false);
    } catch (err) {
      setEmailValidationLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);

      const config = {
        headers: {
          "content-type": "application/json",
        },
        params: {},
      };

      const payload = {
        id: user?.id,
        forename: forename,
        surname: surname,
        email: email,
        password: confirmPassword,
        role: role,
        status: status,
        staffNumber: staffNumber,
        nmcNumber: nmcNumber,
        accessNiNumber: accessniNumber,
        eLearnUsername: eLearnUsername,
        trustIds: selectedTrustIds,
        telephone: telephone,
        dob: null,
        startDate: startDate?.toISOString(),
        rn: isRn,
        rm: isRm,
        rmn: isRmn,
        rnld: isRnld,
        rscn: isRscn,
        hca2: isHca2,
        hca3: isHca3,
        ldoc: isLdoc,
        lcon: isLcon,
        supportWorker: isSupportWorker,
        radiographer: isRadiographer,
        physiotherapist: isPhysiotherapist,
        labAssistant: isLabAssistant,
        bioMedicalScientist: isBioMedicalScientist,
        speechTherapist: isSpeechTherapist,
        occupationalTherapist: isOccupationalTherapist,
        pharmacist: isPharmacist,
      };

      const isUpdate = user?.id !== null && user?.id !== undefined;
      const response = await authAxios().post(
        "/api/backoffice/users/" + (isUpdate ? "update" : "create"),
        payload,
        config,
      );
      setLoading(false);

      if (onComplete !== null && onComplete !== undefined)
        onComplete(response.data);

      const newUserId = response.data.id;
      const newUser = "/users/" + newUserId;
      navigate(newUser, { replace: true });

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("error:");
      console.log(err);
    }
  };

  const emailChanged = (value) => {
    var text = value.target.value;
    setEmail(text.trim());
  };

  const passwordChanged = (value) => {
    var text = value.target.value;
    setPassword(text);
  };

  const confirmPasswordChanged = (value) => {
    var text = value.target.value;
    setConfirmPassword(text);
  };

  const forenameChanged = (value) => {
    var text = value.target.value;
    setForename(text);
  };

  const surnameChanged = (value) => {
    var text = value.target.value;
    setSurname(text);
  };

  const staffNumberChanged = (value) => {
    var text = value.target.value;
    setStaffNumber(text);
  };
  const nmcNumberChanged = (value) => {
    var text = value.target.value;
    setNmcNumber(text);
  };

  const accessniNumberChanged = (value) => {
    var text = value.target.value;
    setAccessniNumber(text);
  };

  const telephoneChanged = (value) => {
    var text = value.target.value;
    setTelephone(text);
  };

  const toggleRn = () => {
    setRn(!isRn);
  };
  const toggleRm = () => {
    setRm(!isRm);
  };
  const toggleRmn = () => {
    setRmn(!isRmn);
  };
  const toggleRnld = () => {
    setRnld(!isRnld);
  };
  const toggleHca2 = () => {
    setHca2(!isHca2);
  };
  const toggleHca3 = () => {
    setHca3(!isHca3);
  };
  const toggleRscn = () => {
    setRscn(!isRscn);
  };
  const toggleLdoc = () => {
    setLdoc(!isLdoc);
  };
  const toggleLcon = () => {
    setLcon(!isLcon);
  };
  const toggleSupportWorker = () => {
    setSupportWorker(!isSupportWorker);
  };
  const toggleRadiographer = () => {
    setRadiographer(!isRadiographer);
  };
  const togglePhysiotherapist = () => {
    setPhysiotherapist(!isPhysiotherapist);
  };
  const toggleLabAssistant = () => {
    setLabAssistant(!isLabAssistant);
  };
  const toggleBioMedicalScientist = () => {
    setBioMedicalScientist(!isBioMedicalScientist);
  };
  const toggleSpeechTherapist = () => {
    setSpeechTherapist(!isSpeechTherapist);
  };
  const toggleOccupationalTherapist = () => {
    setOccupationalTherapist(!isOccupationalTherapist);
  };
  const togglePharmacist = () => {
    setPharmacist(!isPharmacist);
  };

  const passwordSection = () => {
    if (user === null || user === undefined) {
      return (
        <Row className="mb-3">
          <Col lg={6}>
            <Form.Group controlId="formPassword">
              <Form.Label>Password *</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={passwordChanged}
                isValid={passwordValid}
                isInvalid={!passwordValid}
                placeholder="Enter password"
                required
              />
              <Form.Control.Feedback type="invalid">
                {passwordRejectReason}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={6}>
            <Form.Group controlId="formConfirmPassword">
              <Form.Label>Confirm Password *</Form.Label>
              <Form.Control
                type="password"
                value={confirmPassword}
                onChange={confirmPasswordChanged}
                isValid={confirmPasswordValid}
                isInvalid={!confirmPasswordValid}
                placeholder="Confirm password"
                required
              />
              <Form.Control.Feedback type="invalid">
                {confirmPasswordRejectReason}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      );
    }
  };

  const gradeTypeSelection = () => {
    if (!needGradeTypeSelection) return;

    return (
      <Card className="mb-4">
        <Card.Header>
          <h6 className="mb-0">Professional Qualifications</h6>
          <small className="text-muted">Select all applicable qualifications for this user</small>
        </Card.Header>
        <Card.Body>
          <Row className="mb-3">
            <Col lg={4}>
              <Form.Group controlId="formRn">
                <Form.Check
                  type="checkbox"
                  label="Registered Nurse (RN)"
                  checked={isRn}
                  onChange={toggleRn}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formRm">
                <Form.Check
                  type="checkbox"
                  label="Registered Midwife (RM)"
                  checked={isRm}
                  onChange={toggleRm}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formRmn">
                <Form.Check
                  type="checkbox"
                  label="Registered Mental Health Nurse (RMN)"
                  checked={isRmn}
                  onChange={toggleRmn}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col lg={4}>
              <Form.Group controlId="formRnld">
                <Form.Check
                  type="checkbox"
                  label="Learning Disabilities Nurse (RNLD)"
                  checked={isRnld}
                  onChange={toggleRnld}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formRscn">
                <Form.Check
                  type="checkbox"
                  label="Registered Sick Children's Nurse (RSCN)"
                  checked={isRscn}
                  onChange={toggleRscn}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={4}>
              <Form.Group controlId="formHca2">
                <Form.Check
                  type="checkbox"
                  label="Band 2 Healthcare Assistant"
                  checked={isHca2}
                  onChange={toggleHca2}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formHca3">
                <Form.Check
                  type="checkbox"
                  label="Band 3 Healthcare Assistant"
                  checked={isHca3}
                  onChange={toggleHca3}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3 mt-3">
            <Col lg={4}>
              <Form.Group controlId="formLdoc">
                <Form.Check
                  type="checkbox"
                  label="Locum Doctor (LDOC)"
                  checked={isLdoc}
                  onChange={toggleLdoc}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formLcon">
                <Form.Check
                  type="checkbox"
                  label="Locum Consultant (LCON)"
                  checked={isLcon}
                  onChange={toggleLcon}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col lg={4}>
              <Form.Group controlId="formSupportWorker">
                <Form.Check
                  type="checkbox"
                  label="Support worker"
                  checked={isSupportWorker}
                  onChange={toggleSupportWorker}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formRadiographer">
                <Form.Check
                  type="checkbox"
                  label="Radiographer"
                  checked={isRadiographer}
                  onChange={toggleRadiographer}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formPhysiotherapist">
                <Form.Check
                  type="checkbox"
                  label="Physiotherapist"
                  checked={isPhysiotherapist}
                  onChange={togglePhysiotherapist}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col lg={4}>
              <Form.Group controlId="formLabAssistant">
                <Form.Check
                  type="checkbox"
                  label="Lab assistant"
                  checked={isLabAssistant}
                  onChange={toggleLabAssistant}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formBioMedicalScientist">
                <Form.Check
                  type="checkbox"
                  label="Bio-medical scientist"
                  checked={isBioMedicalScientist}
                  onChange={toggleBioMedicalScientist}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formSpeechTherapist">
                <Form.Check
                  type="checkbox"
                  label="Speech therapist"
                  checked={isSpeechTherapist}
                  onChange={toggleSpeechTherapist}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col lg={4}>
              <Form.Group controlId="formOccupationalTherapist">
                <Form.Check
                  type="checkbox"
                  label="Occupational therapist"
                  checked={isOccupationalTherapist}
                  onChange={toggleOccupationalTherapist}
                />
              </Form.Group>
            </Col>
            <Col lg={4}>
              <Form.Group controlId="formPharmacist">
                <Form.Check
                  type="checkbox"
                  label="Pharmacist"
                  checked={isPharmacist}
                  onChange={togglePharmacist}
                />
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };

  return (
    <Fragment>
      <Form onSubmit={onSave}>
        {/* Personal Information Section */}
        <Card className="mb-4">
          <Card.Header>
            <h6 className="mb-0">Personal Information</h6>
          </Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Col lg={6}>
                <Form.Group controlId="formForename">
                  <Form.Label>First Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={forename}
                    onChange={forenameChanged}
                    isValid={forenameValid}
                    isInvalid={!forenameValid}
                    placeholder="Enter first name"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {forenameRejectReason}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group controlId="formSurname">
                  <Form.Label>Last Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={surname}
                    onChange={surnameChanged}
                    isValid={surnameValid}
                    isInvalid={!surnameValid}
                    placeholder="Enter last name"
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {surnameRejectReason}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col lg={6}>
                <Form.Group controlId="formEmail">
                  <Form.Label>Email Address *</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={emailChanged}
                    isValid={emailValid}
                    isInvalid={!emailValid}
                    placeholder="Enter email address"
                    required
                  />
                  {emailValidationLoading && (
                    <div className="mt-1">
                      <AxisSpinner loading={emailValidationLoading} />
                    </div>
                  )}
                  <Form.Control.Feedback type="invalid">
                    {emailRejectReason}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group controlId="formTelephone">
                  <Form.Label>Telephone</Form.Label>
                  <Form.Control
                    type="text"
                    value={telephone}
                    onChange={telephoneChanged}
                    placeholder="Enter phone number"
                  />
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Account & Role Section */}
        <Card className="mb-4">
          <Card.Header>
            <h6 className="mb-0">Account & Role</h6>
          </Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Col lg={6}>
                <Form.Group controlId="formRole">
                  <Form.Label>Role *</Form.Label>
                  <Form.Control
                    as={DropDownUserRoleSelection}
                    filtered={true}
                    onSelected={setRole}
                    defaultValue={role}
                    isValid={roleValid}
                    isInvalid={!roleValid}
                    required
                    placeholderText="Select Role"
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a role
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col lg={6}>
                <Form.Group controlId="formStartDate">
                  <Form.Label>Start Date *</Form.Label>
                  <Form.Control
                    as={DateTimePicker}
                    onChange={setStartDate}
                    value={startDate}
                    isValid={startDateValid}
                    isInvalid={!startDateValid}
                    format={"y-MM-dd"}
                    disableClock={true}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    Please select a start date
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col lg={6}>
                <Form.Group controlId="formStatus">
                  <Form.Label>Status *</Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    required
                  >
                    <option value="ACTIVE">Active</option>
                    <option value="PENDING">Pending</option>
                    <option value="HOLD">On Hold</option>
                    <option value="BLOCKED">Blocked</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {passwordSection()}
          </Card.Body>
        </Card>

        {/* Professional Details Section */}
        <Card className="mb-4">
          <Card.Header>
            <h6 className="mb-0">Professional Details</h6>
          </Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Col lg={4}>
                <Form.Group controlId="formStaffNumber">
                  <Form.Label>Staff Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={staffNumber}
                    onChange={staffNumberChanged}
                    placeholder="Enter staff number"
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group controlId="formNmcNumber">
                  <Form.Label>NMC Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={nmcNumber}
                    onChange={nmcNumberChanged}
                    placeholder="Enter NMC number"
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group controlId="accessniNumber">
                  <Form.Label>Access NI Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={accessniNumber}
                    onChange={accessniNumberChanged}
                    placeholder="Enter Access NI number"
                  />
                </Form.Group>
              </Col>
              <Col lg={4}>
                <Form.Group controlId="eLearnUsername">
                  <Form.Label>E-Learning Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={eLearnUsername ?? ""}
                    onChange={(e) => setELearnUsername(e.target.value)}
                    placeholder="Enter e-learning username"
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <Form.Group controlId="trusts">
                  <Form.Label>Trusts</Form.Label>
                  <Row>
                    {availableTrusts.map((trust) => (
                      <Col xs={6} lg={4} key={trust.id}>
                        <Form.Check
                          type="checkbox"
                          id={`trust-${trust.id}`}
                          label={trust.name}
                          checked={selectedTrustIds.includes(trust.id)}
                          onChange={() => toggleTrust(trust.id)}
                        />
                      </Col>
                    ))}
                  </Row>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {gradeTypeSelection()}

        <ButtonModalFormSaveClose
          formSave={onSave}
          close={close}
          saveName={"Save User"}
          loading={saveDisabled}
        />
      </Form>
    </Fragment>
  );
};

export default UserCreation;
